import React from "react";

const Progressbar = ({ value, max }) => {
	return (
		<progress
			className="w-full h-[5px]"
			value={value}
			max={max}
			id="progressBar"></progress>
	);
};

export default Progressbar;
